export default {
  QUERY_ARTICLES_OVERVIEW: {
    url: '/api/v1/knowledge_base/categories',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_ARTICLES_LIST: {
    url: '/api/v1/knowledge_base/articles',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  SAVE_ARTICLES: {
    url: '/api/v1/admin/knowledge_base/articles',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_ARTICLES: {
    url: '/api/v1/admin/knowledge_base/articles',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_ARTICLES: {
    url: '/api/v1/admin/knowledge_base/articles',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
